import GeneralApplicationsTable from "./GeneralApplicationsTable"
import { assignedApps, installedApps } from "../terminalApplicationData"
import React, { useState, useEffect } from "react"
import "../../../../../styleSheets/base/styles.scss"
import {
  Typography,
  Alert,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContentText,
  FormHelperText,
  DialogActions,
  DialogContent,
  Paper,
  Stack,
  Divider,
  Grow,
  Box,
} from "@mui/material"
import "../../styles/terminals.styles.scss"
import api from "../../../../../base/services/ResApi"
import { RequestErrorHandeling } from "../../../../../base/errorHandeling/RequestErrorHandeling"
import Alerts from "../../../../../base/errorHandeling/Alerts"
import noConnectionDtl from "../../../../../../resources/noConncDtl200.gif"
import connectedIcon from "../../../../../../resources/connected200.gif"
import disconnectedIcon from "../../../../../../resources/disconnected200.gif"
import activeTerminal from "../../../../../../resources/activeTerminal.png"
import inactiveTerminal from "../../../../../../resources/inactiveTerminal.png"
import OperationStatus from "./operations/OperationStatus"
import InstalledApplicationsDropdown, { installedPackageName } from "../../../../components/installedApplicationsDropdown/InstalledApplicationsDropdown"
import ConfirmationModal from "../../../../components/confirmationModal/ConfirmationModal"
import PasswordConfirmModal from "../../../../components/confirmationModal/PasswordConfirmModal"

import RefreshIcon from "@mui/icons-material/Refresh"
import TerminalOperations from "./TerminalOperations"

const GeneralInfo = (props) => {
  // set pngs
  const [connectionIcon, setConnectionIcon] = useState(noConnectionDtl)
  const [connectionStatus, setConnectionStatus] = useState("")
  const [terminalStatusIcon, setTerminalStatusIcon] = useState(inactiveTerminal)
  const [terminalStatus, setTerminalStatus] = useState("")
  const [isSubmit, setIsSubmit] = useState(false)
  const [operation, setOperation] = useState()
  const [operationLabel, setOperationLabel] = useState("")
  const [appId, setAppId] = useState("")
  const [updateApplication, setUpdateApplication] = useState(null)
  const isUpdateApplicationSelected = !!props.approvedData?.serialNo
    && updateApplication?.serialNo === props.approvedData?.serialNo
    && updateApplication?.applicationId != null && updateApplication.applicationId !== ""
    && assignedApps(props.approvedData).some((app) => app.applicationId === updateApplication.applicationId)
  const [selectedTerminalSerial, setSelectedTerminalSerial] = useState("")
  const [appIdError, setAppIdError] = useState("")
  const isInstalledApplicationSelected = selectedTerminalSerial === props.approvedData?.serialNo
    && !!appId && (installedApps(props.approvedData) || []).some((app) => installedPackageName(app) === appId)

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  const [opStatusModalOpen, setOpStatusModalOpen] = useState(false)
  const [confirmModelOpen, setConfirmModelOpen] = useState(false)
  const [pwConfirmModelOpen, setPwConfirmModelOpen] = useState(false)


  //clear all alerts after a timeout
  useEffect(() => {
    if ((iserror || isSuccess) === true) {
      let timerId = setTimeout(() => {
        setIserror(false)
        setErrorMessages([])
        setSuccessMessages([])
        setIsSuccess(false)
        timerId = null
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [iserror, isSuccess])

  useEffect(() => {
    if (props.approvedData?.connStatus == null) {
      setConnectionIcon(noConnectionDtl)
      setConnectionStatus("Not Available")
    } else if (
      props.approvedData?.connStatus === "CONNECTED"
    ) {
      setConnectionIcon(connectedIcon)
      setConnectionStatus("Connected")
    } else if (
      props.approvedData?.connStatus === "DISCONNECTED"
    ) {
      setConnectionIcon(disconnectedIcon)
      setConnectionStatus("Disconnected")
    }

    if (props.approvedData?.status == null) {
      setTerminalStatusIcon(inactiveTerminal)
      setTerminalStatus("Terminal Status Not Available")
    } else if (props.approvedData?.status === "ACTIVE") {
      setTerminalStatusIcon(activeTerminal)
      setTerminalStatus("Active")
    } else if (props.approvedData?.status === "INACTIVE") {
      setTerminalStatusIcon(inactiveTerminal)
      setTerminalStatus(props.approvedData?.status)
    } else {
      setTerminalStatusIcon(inactiveTerminal)
      setTerminalStatus(props.approvedData?.status)
    }
  }, [props.approvedData])

  const handleOpReqId = (operation, opReqID) => {
    localStorage.setItem(operation, opReqID)
  }

  const handleOperatios = () => {
    if (isSubmit) return
    if (operation === "TRIGGER_SFT_UPDATE" && !isUpdateApplicationSelected) return
    if (operation === "UNINSTALL_APP" && (!isInstalledApplicationSelected || /\s|[^\x21-\x7E]/.test(appId))) {
      setAppIdError("Select an application with a valid package name.")
      return
    }
    setIsSubmit(true)
    let config = {
      headers: {
        Operation: operation,
        ...(operation === "UNINSTALL_APP" ? { "X-App-Id": appId.trim() } : {}),
        ...(operation === "TRIGGER_SFT_UPDATE" ? { "X-Application-Id": updateApplication.applicationId } : {}),
      },
    }

    api
      .get("/terminal/operations/" + props.approvedData?.serialNo, config)
      .then((res) => {
        setIsSubmit(false)
        setConfirmModelOpen(false)
        setPwConfirmModelOpen(false)
        handleOpReqId(operation, res.headers["ops-request-id"])
        setErrorMessages([])
        setIserror(false)
        setIsSuccess(true)
        setSuccessMessages([res.data?.description])
        setTimeout(() => {
          setIsSuccess(false)
          setSuccessMessages([])
        }, 3000)
      })
      .catch((err) => {
        setIsSubmit(false)
        setConfirmModelOpen(false)
        setIsSuccess(false)
        RequestErrorHandeling(err, setIserror, setErrorMessages, setIserrorShow)
        setTimeout(() => {
          setIserror(false)
          setErrorMessages([])
          setIserrorShow(false)
        }, 3000)
      })
  }

  return (
    <form>
      <Grow in={true} style={{ transformOrigin: "0 0 0" }} timeout={1000}>
        <DialogContent
          dividers
          className="terminalGeneralInfoContent"
          sx={{
            padding: { xs: 2, md: 3 },
            marginTop: 0,
            bgcolor: "#f5f8fa",
            overflow: "visible",
          }}
        >
          <div>
            <Alerts
              iserror={iserror}
              errorMessages={errorMessages}
              isSuccess={isSuccess}
              successMessages={successMessages}
              iserrorShow={iserrorShow}
            />
          </div>
          <Stack spacing={2.5} sx={{ width: "100%", minWidth: 0 }}>
            {props.refreshError && <Alert severity="error">{props.refreshError}</Alert>}
            <Paper variant="outlined" sx={{ borderRadius: 3, borderColor: "#dce7e7", overflow: "hidden", boxShadow: "0 4px 18px #163b3b08" }}>
              <Box sx={{ p: { xs: 2, md: 2.5 }, background: "linear-gradient(115deg, #edf7f6 0%, #ffffff 65%)" }}>
                <Stack direction={{ xs: "column", md: "row" }} spacing={2} justifyContent="space-between" sx={{ mb: 2.5 }}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ p: 1.5, bgcolor: "#eaf5f4", borderRadius: 2, display: "flex" }}>
                      <Box component="img" src={terminalStatusIcon} alt="" sx={{ width: 40, height: 40, objectFit: "contain" }} />
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="caption" color="text.secondary">Terminal serial</Typography>
                      <Typography component="h2" variant="h5" fontWeight={700} sx={{ overflowWrap: "anywhere", color: "#163e40" }}>{props.approvedData?.serialNo || "Not available"}</Typography>
                    </Box>
                  </Stack>
                  <Stack direction="row" spacing={1} alignItems="center" useFlexGap flexWrap="wrap">
                    <Box component="span" sx={{ px: 1.5, py: 0.75, borderRadius: 2, fontSize: 13, fontWeight: 600, bgcolor: props.approvedData?.status === "ACTIVE" ? "#e8f5e9" : "action.hover", color: props.approvedData?.status === "ACTIVE" ? "success.dark" : "text.secondary" }}>{terminalStatus || "Status not available"}</Box>
                    <Stack direction="row" spacing={0.75} alignItems="center" sx={{ px: 1.25, py: 0.5, border: "1px solid #e1e8eb", borderRadius: 2 }}>
                      <Box component="img" src={connectionIcon} alt="" sx={{ width: 24, height: 24 }} />
                      <Typography variant="body2" color={connectionStatus === "Connected" ? "success.dark" : connectionStatus === "Disconnected" ? "error.dark" : "text.secondary"}>Connection: {connectionStatus || "Not available"}</Typography>
                    </Stack>
                    {props.onRefresh && <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                      <Button variant="outlined" size="small" onClick={props.onRefresh}
                        disabled={props.refreshing || isSubmit || !props.approvedData?.serialNo}
                        startIcon={props.refreshing ? <CircularProgress size={16} color="inherit" /> : <RefreshIcon />}
                        sx={{ textTransform: "none", borderRadius: 2 }}>
                        {props.refreshing ? "Refreshing…" : "Refresh"}
                      </Button>
                    </Box>}
                  </Stack>
                </Stack>
                <Box component="dl" sx={{ m: 0, display: "grid", gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", md: "repeat(4, minmax(0, 1fr))" }, gap: 1.5, pt: 2, borderTop: "1px solid #deebeb" }}>
                  {[["Model", props.approvedData?.model], ["Organization", props.approvedData?.orgName],
                    ["Organization code", props.approvedData?.orgCode], ["Group", props.approvedData?.groupName || "Unassigned"]
                  ].map(([label, value]) => <Box key={label} sx={{ px: 1.5, py: 1, bgcolor: "#ffffffb8", border: "1px solid #e5eeee", borderRadius: 2 }}>
                    <Typography component="dt" variant="caption" color="text.secondary">{label}</Typography>
                    <Typography component="dd" variant="body2" sx={{ m: 0, mt: 0.5, fontWeight: 600, overflowWrap: "anywhere" }}>{value ?? "Not available"}</Typography>
                  </Box>)}
                </Box>
              </Box>
              <TerminalOperations
                model={props.approvedData?.model}
                isSubmit={isSubmit}
                onViewStatus={() => setOpStatusModalOpen(true)}
                onOperation={(label, value, passwordRequired) => {
                  setOperation(value)
                  setOperationLabel(label)
                  if (value === "UNINSTALL_APP") { setAppId(""); setSelectedTerminalSerial(""); setAppIdError("") }
                  if (passwordRequired) setPwConfirmModelOpen(true)
                  else setConfirmModelOpen(true)
                }}
              />
            </Paper>
            <GeneralApplicationsTable
              applications={assignedApps(props.approvedData)}
              isSubmit={isSubmit || !props.approvedData?.serialNo}
              onTriggerUpdate={(app) => {
                setUpdateApplication({ ...app, serialNo: props.approvedData?.serialNo })
                setOperation("TRIGGER_SFT_UPDATE")
                setConfirmModelOpen(true)
              }}
            />
            <GeneralApplicationsTable applications={installedApps(props.approvedData)} installed />
            <Stack direction={{ xs: "column", sm: "row" }} spacing={{ xs: 0.5, sm: 3 }} sx={{ px: 0.5 }}>
              {[["Created", props.approvedData?.createdDateTime], ["Last updated", props.approvedData?.updatedDateTime]].map(([label, value]) =>
                <Typography key={label} variant="caption" color="text.secondary">{label}: {value ?? "Not available"}</Typography>
              )}
            </Stack>
          </Stack>
        </DialogContent>
      </Grow>
      <Divider />
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={props.onClose} variant="outlined" color="error">
          Cancel
        </Button>
      </DialogActions>
      <OperationStatus
        open={opStatusModalOpen}
        onClose={() => setOpStatusModalOpen(false)}
      />
      <ConfirmationModal
        open={confirmModelOpen && operation !== "UNINSTALL_APP" && operation !== "TRIGGER_SFT_UPDATE"}
        isSubmit={isSubmit}
        handleAccept={handleOperatios}
        onClose={() => {
          setConfirmModelOpen(false)
        }}
      />
      <Dialog
        open={confirmModelOpen && operation === "TRIGGER_SFT_UPDATE"}
        onClose={() => { if (!isSubmit) setConfirmModelOpen(false) }}
        fullWidth
        maxWidth="sm"
        aria-labelledby="software-update-title"
      >
        <DialogTitle id="software-update-title">Trigger software update</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Trigger a software update for {updateApplication?.appName || updateApplication?.appId || "the selected application"} on terminal {updateApplication?.serialNo}?
          </DialogContentText>
          {!isUpdateApplicationSelected && <Alert severity="warning" sx={{ mt: 2 }}>Select an application assigned to the current terminal.</Alert>}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button disabled={isSubmit} onClick={() => setConfirmModelOpen(false)}>Cancel</Button>
          <Button variant="contained" disabled={isSubmit || !isUpdateApplicationSelected} onClick={handleOperatios}>
            {isSubmit ? "Sending…" : "Trigger update"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmModelOpen && operation === "UNINSTALL_APP"}
        onClose={() => { if (!isSubmit) setConfirmModelOpen(false) }}
        fullWidth
        maxWidth="sm"
        aria-labelledby="uninstall-app-title"
      >
        <DialogTitle id="uninstall-app-title">Uninstall an application</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Select the application to remove from terminal {props.approvedData?.serialNo}.
            You will verify your password before confirming the uninstall request.
          </DialogContentText>
          <InstalledApplicationsDropdown
            terminal={props.approvedData}
            value={isInstalledApplicationSelected ? appId : ""}
            isDisabled={isSubmit}
            error={!!appIdError}
            autoFocus
            menuPortalTarget={document.body}
            onChange={(app) => {
              const packageName = installedPackageName(app)
              setSelectedTerminalSerial(props.approvedData?.serialNo)
              setAppId(packageName)
              setAppIdError(app && (!packageName || /\s|[^\x21-\x7E]/.test(packageName))
                ? "This application has no valid package name. Select another application."
                : "")
            }}
          />
          <FormHelperText error={!!appIdError}>
            {appIdError || (isInstalledApplicationSelected ? `Package name: ${appId}` : "Select an application installed on this terminal.")}
          </FormHelperText>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button disabled={isSubmit} onClick={() => setConfirmModelOpen(false)}>Cancel</Button>
          <Button variant="contained" color="error" disabled={isSubmit || !isInstalledApplicationSelected || !!appIdError} onClick={() => { setConfirmModelOpen(false); setPwConfirmModelOpen(true) }}>
            Continue
          </Button>
        </DialogActions>
      </Dialog>
      {pwConfirmModelOpen && <PasswordConfirmModal
        key={`${props.approvedData?.serialNo}-${operation}-${appId}`}
        open={pwConfirmModelOpen}
        operationLabel={operationLabel}
        terminalSerial={props.approvedData?.serialNo}
        packageName={operation === "UNINSTALL_APP" ? appId : undefined}
        acceptDisabled={operation === "UNINSTALL_APP" && (!isInstalledApplicationSelected || !!appIdError)}
        isSubmit={isSubmit}
        handleAccept={handleOperatios}
        onClose={() => {
          setPwConfirmModelOpen(false)
        }}
      />}
    </form>
  )
}

export default GeneralInfo
